import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {environment} from "@env/environment";
import {MasterDetailCrudComponent} from "@ui-webkit/components/crud-master-detail/master-detail-crud.component";
import {PlatformRole} from "@features/rbac-config/config-roles/platform-role.model";

@Component({
  selector: 'app-feature-config-roles',
  standalone: true,
  imports: [CommonModule, MasterDetailCrudComponent],
  templateUrl: './feature-config-roles.component.html'
})
export class FeatureConfigRolesComponent {
  protected modelType = PlatformRole;
  protected apiEndpointRoot = `${environment.apiSecurityHost}/platform/rbac/roles`;
  protected apiEndpointPOSTTemplate = '/{code}';

  protected formTitle: string = 'Platform Role';
  protected formSubtitle: string = 'Add or edit a specific role.';
  protected tableTitle: string = 'Platform Roles';
  protected tableSubtitle: string = 'Platform roles are used to group features.';
}
